import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.scss';

/* Core Input component used for <Radio /> and <Checkbox /> */
const Input = ({
  id,
  type,
  name,
  isMuted,
  labelContent,
  onChange,
  isChecked,
  isDisabled,
  isLabelLeft,
  isLabelLeftOnMobile,
}) => {
  const input = (
    <input
      id={id}
      value={id}
      name={name}
      type={type}
      disabled={isDisabled}
      className={classnames(styles.input, styles[type])}
      onChange={onChange}
      checked={isChecked}
    />
  );

  return (
    <label
      htmlFor={id}
      className={classnames(styles.label, {
        [styles.disabled]: isDisabled,
        [styles.muted]: isMuted,
        [styles.labelLeft]: isLabelLeft,
        [styles.labelLeftOnMobile]: isLabelLeftOnMobile,
      })}
    >
      {input}
      {labelContent && <span>{labelContent()}</span>}
    </label>
  );
};

Input.propTypes = {
  /* Id will be used for the label htmlFor and input id attributes */
  id: PropTypes.string.isRequired,

  /* Only two supported types currently required, add more if necessary */
  type: PropTypes.oneOf(['radio', 'checkbox']).isRequired,

  /* Callback for the onChange event of the input */
  onChange: PropTypes.func.isRequired,

  /* Render function for label content */
  labelContent: PropTypes.func,

  /* Triggers disabled state on input and corresponding styles for label */
  isDisabled: PropTypes.bool,

  /* Muted style - similar to disabled but still selectable */
  isMuted: PropTypes.bool,

  /* Alternative layout with label on the left of the input, currently only used for mobile web */
  isLabelLeft: PropTypes.bool,

  /* Label on the left of the input on mobile */
  isLabelLeftOnMobile: PropTypes.bool,

  /* Maps to input checked attribute */
  isChecked: PropTypes.bool,

  /* Maps to input name attribute */
  name: PropTypes.string,
};

Input.defaultProps = {
  isDisabled: false,
  isMuted: false,
  isLabelLeft: false,
  isLabelLeftOnMobile: false,
  name: undefined,
  isChecked: false,
  labelContent: undefined,
};

export default Input;
